import { DateRangeDropdownV2 } from '@/components/custom/erp';
import DocumentNumberRange from '../DocumentNumberRange';
import { Label } from '@/components/ui/label';

const BasicInfo: React.FC = () => {
  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex w-[61%] items-center'>
          <Label className='w-40 min-w-40'>Ngày từ/đến:</Label>
          <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Số c/từ (từ/đến):</Label>
          <DocumentNumberRange fromDocumentNumberName='so_ct1' toDocumentNumberName='so_ct2' />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
